import React from 'react';

const CurrentUserContext = React.createContext();

export { CurrentUserContext };
